export default function customToast(severity, message, setOpen, setSeverity, setMessage, handleClose) {
    setOpen(true);
    setSeverity(severity);
    setMessage(message);
    if (handleClose){
        handleClose();
    }
}